import React, { useEffect } from "react";
import { usePrevision } from "../../hooks/datosPrevisionales";
import NumberFormat from "react-number-format";
import { HeadInput } from "../ui/HeadInput";
import ErrorInput from "../ui/ErrorInput";
import PropTypes from "prop-types";

const FormDatosPrevision = ({ formik }) => {
  const { getListaAfp, getListaSalud, listadoAfp, listadoPrevision } = usePrevision();

  const getInfo = () => {
    getListaAfp("afp", { jubilado: 0 });
    getListaSalud("prevision", null);
  };

  useEffect(() => {
    getInfo();
  }, []);

  useEffect(() => {
    if (formik.values.datosPrevision.previsionSalud === "1") {
      formik.values.datosPrevision.planPactado = 0;
      formik.setValues(formik.values);
    }
  }, [formik.values.datosPrevision.previsionSalud]);

  useEffect(() => {
    getListaAfp("afp", { jubilado: formik.values.datosPrevision.jubilado });
  }, [formik.values.datosPrevision.jubilado]);

  return (
    <>
      <div className="row mt-3">
        <div className="col-12 col-sm-6 my-1">
          <label htmlFor="certificadoCovid">Tiene certificado covid</label>
          <select className="form-select" name="datosPrevision.certificadoCovid" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPrevision.certificadoCovid}>
            <option value="">Seleccione</option>
            <option value={0}>No</option>
            <option value={1}>Si</option>
          </select>
        </div>
        <div className="col-12 col-sm-6 my-1">
          <label htmlFor="certificadoDiscapacidad">Tiene certificado discapacidad</label>
          <select className="form-select" name="datosPrevision.certificadoDiscapacidad" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPrevision.certificadoDiscapacidad}>
            <option value="">Seleccione</option>
            <option value={0}>No</option>
            <option value={1}>Si</option>
          </select>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-sm-6 my-1">
          <HeadInput label="Jubilado *" formik={formik} html_for="jubilado" datosObj="datosPrevision" />
          <select className="form-select" name="datosPrevision.jubilado" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPrevision.jubilado}>
            <option value="">Seleccione</option>
            <option value={0}>No</option>
            <option value={1}>Si</option>
          </select>
        </div>
        <div className="col-12 col-sm-6 my-1">
          <HeadInput label="Previsión de salud *" formik={formik} html_for="previsionSalud" datosObj="datosPrevision" />
          <select className="form-select" name="datosPrevision.previsionSalud" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPrevision.previsionSalud}>
            <option value="">Seleccione</option>
            {listadoPrevision && (
              <>
                {listadoPrevision.map(prevision => (
                  <option key={prevision.id} value={prevision.id}>
                    {prevision.nombre}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-sm-6 my-1">
          <HeadInput label="Previsión social *" formik={formik} html_for="previsionSocial" datosObj="datosPrevision" />
          <select className="form-select" name="datosPrevision.previsionSocial" aria-label="Default select example" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.datosPrevision.previsionSocial}>
            <option value="">Seleccione</option>
            {Array.isArray(listadoAfp) && (
              <>
                {listadoAfp.map(afp => (
                  <option key={afp.id} value={afp.id}>
                    {afp.nombre}
                  </option>
                ))}
              </>
            )}
          </select>
        </div>

        {Number.parseInt(formik.values.datosPrevision.previsionSalud) !== 1 && formik.values.datosPrevision.previsionSalud !== "" && (
          <div className="col-6">
            <HeadInput label="Plan pactado *" formik={formik} html_for="planPactado" datosObj="datosPrevision" />
            <div className="input-group">
              <span className="input-group-text" id="inputGroup-sizing-default">
                UF
              </span>
              <NumberFormat
                className="form-control"
                autoComplete="nope"
                name="datosPrevision.planPactado"
                value={formik.values.datosPrevision.planPactado}
                style={{ paddingLeft: "10px" }}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                decimalScale={4}
                thousandSeparator="."
                decimalSeparator=","
                isAllowed={(values, sourceInfo) => {
                  const { value } = values;
                  return value <= 99.9999;
                }}
                allowNegative={false}
              />
            </div>
            {formik.touched.datosPrevision && formik.errors.datosPrevision && <ErrorInput touched={formik.touched.datosPrevision.planPactado} error={formik.errors.datosPrevision.planPactado} />}
          </div>
        )}
      </div>
    </>
  );
};

FormDatosPrevision.propTypes = {
  formik: PropTypes.object.isRequired,
};

export default FormDatosPrevision;
